import classNames from 'classnames/bind'
import React, { ReactNode } from 'react'
import { useAppSelector } from '@/redux/hooks'
import { isEmpty, isString } from 'lodash-es'
import Link from 'next/link'

// Libs
import { useServiceList } from './utils/useServiceList'
import { isSiteNavVisibleInRegion } from '@/methods/siteNav'

// Constants
import { REGION } from '@/constants/region'

// Styles
import styles from './style.module.scss'
const cx = classNames.bind(styles)

interface IServiceItem {
  children: ReactNode
  url?: string
  onClick?: () => void
  allowRegions?: Set<string>
  /** 後台「網站選單」的顯示地區（空 = 全部，含 OTHER） */
  regions?: string[]
  /** 後台設定的連結才有；預設頁尾一律新分頁 */
  openNewTab?: boolean
}

export interface IServiceCategory {
  title: string
  items: IServiceItem[]
  isMobileFullWidth?: boolean
  /** 後台「網站選單」欄位的顯示地區 */
  regions?: string[]
}

const ServiceItem = ({ title, items, isMobileFullWidth, regions }: IServiceCategory) => {
  const commonData = useAppSelector((state) => state.common)
  const dittoCountryCode: string =
    !isEmpty(commonData) && !isEmpty(commonData?.locationData) && !isEmpty(commonData?.locationData?._dittoCountryCode)
      ? commonData?.locationData?._dittoCountryCode || REGION.TW
      : REGION.TW

  const visibleItems = items.filter((item) => {
    if (item.allowRegions && !item.allowRegions.has(dittoCountryCode)) return false
    return isSiteNavVisibleInRegion(item.regions, dittoCountryCode)
  })

  // 整欄沒有這個地區看得到的連結就不顯示標題
  if (!isSiteNavVisibleInRegion(regions, dittoCountryCode) || visibleItems.length === 0) return null

  return (
    <div className={cx('service-item', { 'full-width': isMobileFullWidth })}>
      <div className={cx('service-item__title')}>{title}</div>
      <div className={cx('service-item__links')}>
        {visibleItems.map((item, index) => {
          if (isString(item.children)) {
            return (
              <Link
                href={item.url ?? ''}
                onClick={item.onClick}
                className={cx('service-item__links__item')}
                key={`${index}-${item.children}`}
                target={item.openNewTab === false ? undefined : '_blank'}
              >
                {item.children}
              </Link>
            )
          }

          return item.children
        })}
      </div>
    </div>
  )
}

const ServiceList = () => {
  const services = useServiceList()
  return (
    <div className={cx('service-list')}>
      {services.map((service, index) => (
        <ServiceItem key={`${index}-${service.title}`} {...service} />
      ))}
    </div>
  )
}

export default ServiceList
